/**
 * Sticky add-to-cart component
 * Handles mobile-specific scroll behavior for sticky button
 */
class StickyAddToCart extends HTMLElement {
  connectedCallback() {
    this.animQueue = null;
    this.initScrollObserver();
  }

  disconnectedCallback() {
    this.scrollObserver?.disconnect();
    clearTimeout(this.animQueue);
  }

  /**
   * Initialize IntersectionObserver for sticky button behavior
   * Manages fixed/relative positioning based on scroll position
   */
  initScrollObserver() {
    const regularBuyButton = document.querySelector('[data-observer-buy-buttons]');
    const floatingAddToCart = document.querySelector('[data-floating-add-to-cart]');
    const floatingAddToCartGap = document.querySelector('[data-floating-add-to-cart-replace]');

    if (!regularBuyButton || !floatingAddToCart || !floatingAddToCartGap) {
      return;
    }

    let timeoutDuration = 300;

    this.scrollObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        // Only handle mobile logic
        if (window.innerWidth > 1024) return;

        // Buy button is intersecting (visible)
        if (entry.isIntersecting) {
          this.animQueue = null;
          timeoutDuration = 0;
          
          if (entry.boundingClientRect.top < 0) {
            Object.assign(floatingAddToCart.style, { bottom: '-100px', opacity: '0' });
            timeoutDuration = 200;
          }
          
          this.animQueue = setTimeout(() => {
            Object.assign(floatingAddToCart.style, { bottom: '0', opacity: '1' });
            floatingAddToCart.classList.remove(
              'transition-all',
              'duration-300',
              'fixed',
              'z-fixed',
              'p-4',
              'bg-sand'
            );
            floatingAddToCart.classList.add('relative');
            floatingAddToCartGap.classList.remove('block');
            floatingAddToCartGap.classList.add('hidden');
            document.body.classList.remove('chat-button-sticky');
          }, timeoutDuration);
          return;
        }

        // Buy button is not intersecting and scrolled past
        if (entry.boundingClientRect.top < 0) {
          this.animQueue = null;
          floatingAddToCartGap.classList.replace('hidden', 'block');
          document.body.classList.add('chat-button-sticky');
          floatingAddToCart.classList.remove('relative');
          floatingAddToCart.classList.add('fixed', 'z-fixed', 'p-4', 'bg-sand');
          Object.assign(floatingAddToCart.style, { bottom: '-100px', opacity: '0' });
          this.animQueue = setTimeout(() => {
            floatingAddToCart.classList.add('transition-all', 'duration-300');
            Object.assign(floatingAddToCart.style, { bottom: '0', opacity: '1' });
          }, 100);
          return;
        }

        // Buy button is not intersecting but not scrolled past yet
        floatingAddToCart.classList.add('relative');
        floatingAddToCartGap.classList.add('hidden');
      });
    });

    this.scrollObserver.observe(regularBuyButton);
  }
}

customElements.define('sticky-add-to-cart', StickyAddToCart);
